"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HistoryManager =
/*#__PURE__*/
function () {
  function HistoryManager() {
    _classCallCheck(this, HistoryManager);

    this.history = null;
    this.requestCallback = null;
    this.silent = false;
  }

  _createClass(HistoryManager, [{
    key: "setHistory",
    value: function setHistory(history) {
      this.history = history;
    }
  }, {
    key: "setRequestCallback",
    value: function setRequestCallback(requestCallback) {
      this.requestCallback = requestCallback;
    }
  }, {
    key: "changeSilent",
    value: function changeSilent() {
      this.silent = true;
    }
  }, {
    key: "changeUnsilent",
    value: function changeUnsilent() {
      this.silent = false;
    }
  }, {
    key: "listen",
    value: function listen() {
      this.history.listen(this.listenCallback.bind(this));
    }
  }, {
    key: "listenCallback",
    value: function listenCallback(location) {
      if (!this.silent) this.requestCallback(location.pathname);
    }
  }, {
    key: "push",
    value: function push(pathname) {
      this.changeSilent();
      this.requestCallback(pathname);
      this.history.push(pathname);
      this.changeUnsilent();
    }
  }, {
    key: "createHref",
    value: function createHref(pathname) {
      return this.history.createHref({
        pathname: pathname
      });
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      return this.history.location;
    }
  }]);

  return HistoryManager;
}();

exports.default = HistoryManager;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/HistoryManager.js
// module id = 129
// module chunks = 0